export const VARIANTS = {
  SIMPLE: 'simple',
  CONDENSED: 'condensed',
  FULL: 'full',
};

export const DEFAULT_HEIGHT = '200px';

export const TESTING_ID = 'llui-text-editor';

// Matrix code format to line up with color selection dropdown UI
// We specifically use #000001 instead of #000000 because of a bug in fontcolor plugin when hightlighting
// prettier-ignore
export const FONT_COLORS_LIST = [
  '#FFFFFF', '#000001', '#8B1A10', '#EB3323', '#F29D39', '#FFFE55', '#75FA4C', '#73FCFD', '#0021F5', '#8B2CF6', '#EA3EF7',
  '#F2F2F2', '#7F7F7F', '#DFBAB1', '#EECECD', '#F9E6D0', '#FDF2D0', '#DCE9D5', '#D3E0E3', '#D2E2F1', '#D8D3E7', '#E6D2DC',
  '#D8D8D8', '#595959', '#D08370', '#DF9D9B', '#F2CCA2', '#FBE5A3', '#BDD6AC', '#A9C3C8', '#A6C5E5', '#B2A8D3', '#CEA8BC',
  '#BFBFBF', '#3F3F3F', '#BE4B31', '#D26D6A', '#ECB476', '#FAD978', '#9EC284', '#80A4AE', '#7BA8D8', '#8B7EBE', '#B87F9F',
  '#A5A5A5', '#262626', '#982B15', '#BC261A', '#DB944B', '#EAC352', '#78A65A', '#53808C', '#4F85C1', '#6351A2', '#9B5378',
  '#7F7F7F', '#0C0C0C', '#7A2917', '#8D1A10', '#A96324', '#B89130', '#48742C', '#254E5B', '#23538F', '#312171', '#6B2346'
];

export const SIMPLE_DEFAULT_OPTIONS = {
  buttons: ['bold', 'italic', 'underline', 'link', 'html'],
  plugins: ['toolbar_tooltips', 'toolbar_icon', 'source_button'],
  dragImageUpload: false,
  dragFileUpload: false,
  imageCaption: false,
  minHeight: '128px',
  source: true,
};

export const CONDENSED_DEFAULT_OPTIONS = {
  buttons: [
    'bold',
    'italic',
    'underline',
    'fontcolor',
    'indent',
    'outdent',
    'link',
    'html',
  ],
  fontcolors: FONT_COLORS_LIST,
  formatting: [],
  formattingAdd: {
    'p-toggle': {
      title: 'Normal text',
      api: 'module.block.format',
      args: { tag: 'p' },
    },
    pullquote: {
      title: 'Quote',
      api: 'module.block.format',
      args: {
        tag: 'blockquote',
        attr: {
          class: 'quote',
        },
      },
    },
    sidenote: {
      title: 'Sidenote',
      api: 'module.block.format',
      args: { tag: 'blockquote' },
    },
    h3: {
      title: 'Title',
      api: 'module.block.format',
      args: { tag: 'h3' },
    },
    callout: {
      title: 'Callout',
      api: 'module.block.format',
      args: {
        tag: 'blockquote',
        attr: {
          class: 'callout',
        },
      },
    },
  },
  dragImageUpload: false,
  dragFileUpload: false,
  linkSize: 200,
  // imageCaption is being set to false because of a XSS issue with the caption user input. Discussion found on this story https://app.clubhouse.io/lessonly/story/52946/fix-cross-scripting-attack-in-builder
  imageCaption: false,
  minHeight: '128px',
  pasteImages: false,
  plugins: [
    'blank_link_targets',
    'fontcolor',
    'alignment',
    'lists',
    'toolbar_icon',
    'source_button',
    'toolbar_tooltips',
    'strip_nbsp',
  ],
  source: true,
  toolbarFixed: false,
};

export const FULL_DEFAULT_OPTIONS = {
  buttons: [
    'bold',
    'italic',
    'underline',
    'fontcolor',
    'format',
    'indent',
    'outdent',
    'link',
    'html',
  ],
  fontcolors: FONT_COLORS_LIST,
  formatting: [],
  formattingAdd: {
    'p-toggle': {
      title: 'Normal text',
      api: 'module.block.format',
      args: { tag: 'p' },
    },
    footnote: {
      title: 'Footnote',
      api: 'module.block.format',
      args: {
        tag: 'p',
        attr: {
          class: 'footnote',
        },
      },
    },
    h3: {
      title: 'Title',
      api: 'module.block.format',
      args: { tag: 'h3' },
    },
    callout: {
      title: 'Callout',
      api: 'module.block.format',
      args: {
        tag: 'blockquote',
        attr: {
          class: 'callout',
        },
      },
    },
    pullquote: {
      title: 'Quote',
      api: 'module.block.format',
      args: {
        tag: 'blockquote',
        attr: {
          class: 'quote',
        },
      },
    },
    sidenote: {
      title: 'Sidenote',
      api: 'module.block.format',
      args: { tag: 'blockquote' },
    },
    pre: {
      title: 'Code Block',
      api: 'module.block.format',
      args: { tag: 'pre' },
    },
  },
  dragImageUpload: false,
  dragFileUpload: false,
  linkSize: 200,
  // imageCaption is being set to false because of a XSS issue with the caption user input. Discussion found on this story https://app.clubhouse.io/lessonly/story/52946/fix-cross-scripting-attack-in-builder
  imageCaption: false,
  minHeight: DEFAULT_HEIGHT,
  pasteImages: false,
  plugins: [
    'table',
    'blank_link_targets',
    'alignment',
    'lists',
    'inlineCode',
    'fontcolor',
    'toolbar_icon',
    'source_button',
    'toolbar_tooltips',
    'strip_nbsp',
  ],
  source: true,
};
